// [type, text, waitAfterMs?]
export const BOOT_LINES = [
  ["sys", "INITIALISING BIO-SIGNAL TRANSLATOR v4.7…"],
  ["sys", "LOADING KERNEL MODULE myco_bridge.ko … OK"],
  ["sys", "MOUNTING /dev/spore0 … OK"],
  ["dump", "0x00A0F3  6D 79 63 65 6C 69 75 6D  |mycelium|"],
  ["sys", "CHECKING CONTAINMENT FIELD INTEGRITY … 98.2%"],
  ["sys", "CALIBRATING MYCELIAL FREQUENCY BANDS…", 450],
  ["ok", "  BAND 01   0.42 Hz … LOCKED"],
  ["ok", "  BAND 02   1.07 Hz … LOCKED"],
  ["sys", "  BAND 03   3.90 Hz … DRIFTING"],
  ["ok", "  BAND 03   3.88 Hz … LOCKED"],
  ["sys", "SAMPLING AIR: CHAMBER B"],
  ["warn", "SPORE DENSITY: ELEVATED", 650],
  ["sys", "PARTICULATE COUNT 41,880 /m³ … RISING"],
  ["sys", "ENGAGING HEPA SCRUBBERS … OK"],
  ["dump", "0x00A1C0  77 65 20 61 72 65 20 68  |we are h|"],
  ["ok", "HANDSHAKE SUBSTRATE NODE 0x1F … OK"],
  ["ok", "HANDSHAKE SUBSTRATE NODE 0x2A … OK"],
  ["sys", "HANDSHAKE SUBSTRATE NODE 0x2B … NO RESPONSE", 400],
  ["ok", "RETRYING 0x2B … OK"],
  ["sys", "BUILDING LEXICAL MAP (EN-GB) …"],
  ["sys", "  TOKENS: 1,048,576"],
  ["sys", "  SEMANTIC ANCHORS: 2,114"],
  ["sys", "DECRYPTING SIGNAL…", 400],
  ["ok", "  LAYER 1/4 … OK"],
  ["ok", "  LAYER 2/4 … OK"],
  ["ok", "  LAYER 3/4 … OK"],
  ["sys", "  LAYER 4/4 … ", 500],
  ["warn", "WARNING: SIGNAL ORIGIN NOT LOCAL", 650],
  ["sys", "TRIANGULATING SOURCE … EVERYWHERE"],
  ["dump", "0x00A2E8  65 72 65 20 61 6C 72 65  |ere alre|"],
  ["sys", "ELECTRODE IMPEDANCE  D1 4.1 kΩ   D2 4.3 kΩ"],
  ["ok", "SYNCHRONISING DIODE PHASE … OK"],
  ["sys", "NEURAL PATTERN MATCH: 71% … 84% … 96%"],
  ["warn", "WARNING: PATTERN EXHIBITS INTENT", 650],
  ["sys", "QUARANTINE PROTOCOL 7: STANDBY"],
  ["sys", "HOST ORGANISMS IN RANGE: 1 … 4 … 9 …"],
  ["dump", "0x00A3FF  61 64 79 20 68 65 72 65  |ady here|"],
  ["sys", "OPENING TRANSLATION CHANNEL …"],
  ["ok", "CHANNEL OPEN"],
];
